import { Handshake } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const HandshakeIcon = createLucideIcon(Handshake);
